module.exports = __webpack_public_path__ + "static/media/loading-refresh-rotate-svgrepo-com.f359066f.svg";